module.exports = __webpack_public_path__ + "static/media/1.95ee5bdd.png";